import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_PROGRAM_DELETE_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_PROGRAM_DELETE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_PROGRAM_DELETE_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/user-programs/${id}`,
    method: 'DELETE',
    notify: true,
  })
);

export default apiCall;
